"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionCreator = actionCreator;
exports.handleMultipartUpload = handleMultipartUpload;
exports.isSameAttendee = isSameAttendee;
exports.recursiveFunction = recursiveFunction;
exports.toggleLocalUserAudioTrack = toggleLocalUserAudioTrack;
exports.toggleLocalUserVideoTrack = toggleLocalUserVideoTrack;
exports.toggleOverlayStatus = toggleOverlayStatus;
exports.uploadToPreSignedURL = uploadToPreSignedURL;
exports.withTimeout = withTimeout;
var _axios = _interopRequireDefault(require("axios"));
var _retryUtil = require("../retryUtil");
var _md = _interopRequireDefault(require("md5"));
var _feature = require("@studio/feature.flags");
var _constants = require("@studio/constants");
var _metrics = require("@studio/metrics");
var _videoHelpers = require("@cvent/studio-agora/video/videoHelpers");
var _audioHelper = require("@cvent/studio-agora/audio/audioHelper");
var _actions = require("../../actions");
var _setGenericAudioInputDevice = _interopRequireDefault(require("../../actions/meeting/setGenericAudioInputDevice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * Checks if meeting attendee response attendeeId is same as the attendeeId
 * parameter passed in.
 *
 * @param {String} attendeeId
 * @param {Object} state
 *
 * @return {Boolean} returns true of its meting attendee is same
 */
function isSameAttendee(attendeeId, state) {
  var _state$meeting;
  var useAgora = (0, _feature.shouldHaveFeature)('studio.meetingVendor') === _constants.VENDOR_AGORA;
  var localAttendeeId = state === null || state === void 0 || (_state$meeting = state.meeting) === null || _state$meeting === void 0 || (_state$meeting = _state$meeting.attendeeResponse) === null || _state$meeting === void 0 || (_state$meeting = _state$meeting.Attendee) === null || _state$meeting === void 0 ? void 0 : _state$meeting.AttendeeId;
  if (useAgora) {
    localAttendeeId = state.meeting.attendeeId;
  }
  return attendeeId === localAttendeeId;
}

/**
 *
 * @param {*} onSuccess
 * @param {*} onTimeout
 * @param {*} timeout
 */
function withTimeout(onSuccess, onTimeout, timeout) {
  var _this = this;
  var called = false;
  var timer = setTimeout(function () {
    if (called) return;
    called = true;
    onTimeout();
  }, timeout);
  return function () {
    if (called) return;
    called = true;
    clearTimeout(timer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onSuccess.apply(_this, args);
  };
}

/**
 *
 * @param {*} func
 * @param {*} retries
 */
function recursiveFunction(_x, _x2) {
  return _recursiveFunction.apply(this, arguments);
}
/**
 * Basic action creator. Usage:
 *
 * import { SOME_TYPE } from './types';
 import actionCreator from 'creator';
 export default (delta) => actionCreator(SOME_TYPE, {some: 'payload'});;
 *
 * @param {*} type
 * @param {*} payload
 * @param {*?} additionalActions - arrays of additional actions to be dispatched. e.g, [() => togleNotificationList(true)]
 * @returns
 */
function _recursiveFunction() {
  _recursiveFunction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(func, retries) {
    var resp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return func();
        case 3:
          resp = _context.sent;
          return _context.abrupt("return", resp);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          --retries;
          if (!(retries > 0)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", recursiveFunction(func, retries));
        case 12:
          throw _context.t0;
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _recursiveFunction.apply(this, arguments);
}
function actionCreator(type, payload, additionalActions) {
  return function (dispatch) {
    var action = {
      type: type,
      payload: payload
    };
    dispatch(action);
    additionalActions === null || additionalActions === void 0 || additionalActions.map(function (additionalAction) {
      dispatch(additionalAction());
    });
  };
}

/**
 * Util for toggling the hidden status of an overlays
 * with the following structure [{ _id, layer: {}, source: {}}]
 * We can have multiple overlays un-hidden
 * @param {*} overlayId
 * @param {*} overlays
 * @returns
 */

function toggleOverlayStatus(overlayId, overlays) {
  return overlays.map(function (overlay) {
    var source = overlay.source,
      _id = overlay._id;
    return _id === overlayId ? _objectSpread(_objectSpread({}, overlay), {}, {
      source: _objectSpread(_objectSpread({}, source), {}, {
        hidden: !source.hidden
      })
    }) : overlay;
  });
}

/**
 * Upload the binary data content to the pre-signed URL
 * @param {*} preSignedUploadUrl S3 Pre-signed URL where the content should be uploaded
 * @param {*} binaryData         Binary Data
 * @param {*} contentType        Content Type header
 * @param {*} headers            Additional headers
 */
function uploadToPreSignedURL(_x3, _x4, _x5, _x6) {
  return _uploadToPreSignedURL.apply(this, arguments);
}
/**
 * Convert part blob to the binary content
 * @param {*} blobChunk - Blob chunk
 * @returns  {Uint8Array} - Binary content
 */
function _uploadToPreSignedURL() {
  _uploadToPreSignedURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(preSignedUploadUrl, binaryData, contentType, headers) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _retryUtil.retryWithDefaults)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _axios["default"].put(preSignedUploadUrl, binaryData, {
                    headers: _objectSpread({
                      'Content-Type': contentType
                    }, headers && {
                      'x-amz-tagging': headers
                    })
                  });
                case 2:
                  return _context2.abrupt("return", _context2.sent);
                case 3:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          })))["catch"](function (error) {
            throw error;
          });
        case 2:
          return _context3.abrupt("return", _context3.sent);
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _uploadToPreSignedURL.apply(this, arguments);
}
function blobToBinary(_x7) {
  return _blobToBinary.apply(this, arguments);
}
/**
 * Upload the part to the part S3 Pre-signed URL
 * @param {*} partUploadURL  - S3 Pre-signed URL where the content should be uploaded
 * @param {*} part           - Binary Data to be uploaded
 * @param {*} headers         - Additional headers
 * @returns                   - Promise
 */
function _blobToBinary() {
  _blobToBinary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(blobChunk) {
    var buffer;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return blobChunk.arrayBuffer();
        case 2:
          buffer = _context4.sent;
          return _context4.abrupt("return", new Uint8Array(buffer));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _blobToBinary.apply(this, arguments);
}
function uploadPart(_x8, _x9, _x10) {
  return _uploadPart.apply(this, arguments);
}
/**
 *  Upload the file using the multi-part upload workflow
 * @param {*} apiClient                     - API client instance
 * @param {*} teamId                        - Team ID
 * @param {*} eventId                       - Event ID
 * @param {*} docPayload                    - Event Doc payload
 * @param {*} file                          - File to be uploaded
 * @param {*} startFileUploadActionCallback - Callback to start file upload action
 */
function _uploadPart() {
  _uploadPart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(partUploadURL, part, headers) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _retryUtil.retryWithDefaults)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _axios["default"].put(partUploadURL, part, {
                    headers: headers
                  });
                case 2:
                  return _context5.abrupt("return", _context5.sent);
                case 3:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          })))["catch"](function (error) {
            throw error;
          });
        case 2:
          return _context6.abrupt("return", _context6.sent);
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _uploadPart.apply(this, arguments);
}
function handleMultipartUpload(_x11, _x12, _x13, _x14, _x15, _x16) {
  return _handleMultipartUpload.apply(this, arguments);
}
/**
 * Toggles the local user's video track on or off.
 *
 * @param {Object} params - The parameters object
 * @param {Object|null} params.currentVideoTrack - The current video track object, or null if no track exists
 * @param {boolean} params.isCameraOn - Current camera state (true if on, false if off)
 * @param {Object} params.client - The Agora client instance
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {string} params.attendeeId - The ID of the attendee toggling their video
 * @param {boolean} [params.isRemoteToggle=false] - Whether this is a remote toggle action
 * @returns {Promise<Object|null>} Returns the new video track object, or null if video is turned off
 */
function _handleMultipartUpload() {
  _handleMultipartUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(apiClient, teamId, eventId, docPayload, file, startFileUploadActionCallback) {
    var CHUNK_SIZE, UPLOAD_BATCH_SIZE, createDocumentResponse, eventDocId, uploadId, externalVideoId, fileSize, totalChunks, data, partUploadPromises, index, blob, start, end, binary, md5Hash, blobHash, payload, generatePartUploadURLResponse, location, headers, partEtags, completeUploadPayload;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          CHUNK_SIZE = 1024 * 1024 * 30; // 30MB chunks
          UPLOAD_BATCH_SIZE = 4;
          _context7.next = 4;
          return apiClient.eventDoc.createDocument(teamId, eventId, docPayload);
        case 4:
          createDocumentResponse = _context7.sent;
          eventDocId = createDocumentResponse._id, uploadId = createDocumentResponse.uploadId, externalVideoId = createDocumentResponse.externalVideoId; // Start file upload action tracker
          startFileUploadActionCallback === null || startFileUploadActionCallback === void 0 || startFileUploadActionCallback({
            externalVideoId: externalVideoId
          });
          fileSize = file.size;
          totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
          data = [];
          partUploadPromises = [];
          index = 0;
        case 12:
          if (!(index < totalChunks)) {
            _context7.next = 42;
            break;
          }
          blob = void 0;
          start = index * CHUNK_SIZE;
          end = (index + 1) * CHUNK_SIZE;
          if (end > file.size) {
            blob = file.slice(start, file.size);
          } else {
            blob = file.slice(start, end);
          }

          // calculate md5 hash for the part
          _context7.next = 19;
          return blobToBinary(blob);
        case 19:
          binary = _context7.sent;
          md5Hash = (0, _md["default"])(binary);
          blobHash = btoa((md5Hash.match(/\w{2}/g) || []).map(function (a) {
            return String.fromCharCode(parseInt(a, 16));
          }).join(''));
          payload = {
            name: file.name,
            uploadId: uploadId,
            part: {
              md5CheckSum: blobHash,
              partNumber: index + 1,
              contentLength: blob.size
            }
          };
          _context7.next = 25;
          return apiClient.eventDoc.generatePartUploadURL(teamId, eventId, eventDocId, payload);
        case 25:
          generatePartUploadURLResponse = _context7.sent;
          location = generatePartUploadURLResponse.location;
          headers = {
            'Content-MD5': blobHash,
            'Content-Type': 'application/octet-stream'
          };
          partUploadPromises.push(uploadPart(location, blob, headers));
          if (!(partUploadPromises.length === UPLOAD_BATCH_SIZE)) {
            _context7.next = 39;
            break;
          }
          _context7.t0 = [];
          _context7.t1 = _toConsumableArray(data);
          _context7.t2 = _toConsumableArray;
          _context7.next = 35;
          return Promise.all(partUploadPromises);
        case 35:
          _context7.t3 = _context7.sent;
          _context7.t4 = (0, _context7.t2)(_context7.t3);
          data = _context7.t0.concat.call(_context7.t0, _context7.t1, _context7.t4);
          partUploadPromises = [];
        case 39:
          index++;
          _context7.next = 12;
          break;
        case 42:
          if (!(partUploadPromises.length > 0)) {
            _context7.next = 51;
            break;
          }
          _context7.t5 = [];
          _context7.t6 = _toConsumableArray(data);
          _context7.t7 = _toConsumableArray;
          _context7.next = 48;
          return Promise.all(partUploadPromises);
        case 48:
          _context7.t8 = _context7.sent;
          _context7.t9 = (0, _context7.t7)(_context7.t8);
          data = _context7.t5.concat.call(_context7.t5, _context7.t6, _context7.t9);
        case 51:
          partEtags = [];
          data.forEach(function (resolvedPromise, index) {
            var _resolvedPromise$head;
            partEtags.push({
              eTag: resolvedPromise === null || resolvedPromise === void 0 || (_resolvedPromise$head = resolvedPromise.headers) === null || _resolvedPromise$head === void 0 || (_resolvedPromise$head = _resolvedPromise$head.etag) === null || _resolvedPromise$head === void 0 ? void 0 : _resolvedPromise$head.replace(/"/g, ''),
              partNumber: index + 1
            });
          });
          completeUploadPayload = {
            uploadId: uploadId,
            partEtags: partEtags
          };
          _context7.next = 56;
          return apiClient.eventDoc.completeMultiPartUpload(teamId, eventId, eventDocId, completeUploadPayload);
        case 56:
          return _context7.abrupt("return", {
            eventDocId: eventDocId,
            externalVideoId: externalVideoId
          });
        case 57:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _handleMultipartUpload.apply(this, arguments);
}
function toggleLocalUserVideoTrack(_x17) {
  return _toggleLocalUserVideoTrack.apply(this, arguments);
}
/**
 *
 * @param {Object} params                         - The parameters object
 * @param {Object} params.currentAudioTrack       - The current local audio track
 * @param {boolean} params.isMuted                - The desired mute status
 * @param {Object} params.client                  - The Agora client instance
 * @param {Function} params.dispatch              - The Redux dispatch function
 * @param {boolean} [params.isRemoteToggle=false] - Indicates if the toggle is triggered remotely (defaults to false)
 *
 * @returns {Promise<void>} - Returns a promise that resolves when the audio track has been toggled

 */
function _toggleLocalUserVideoTrack() {
  _toggleLocalUserVideoTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(_ref) {
    var currentVideoTrack, isCameraOn, client, dispatch, attendeeId, _ref$isRemoteToggle, isRemoteToggle, deviceActions, sliPayload, newTrack;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          currentVideoTrack = _ref.currentVideoTrack, isCameraOn = _ref.isCameraOn, client = _ref.client, dispatch = _ref.dispatch, attendeeId = _ref.attendeeId, _ref$isRemoteToggle = _ref.isRemoteToggle, isRemoteToggle = _ref$isRemoteToggle === void 0 ? false : _ref$isRemoteToggle;
          deviceActions = {
            addToAttendeeTiles: _actions.addToAttendeeTiles,
            handleVideoInputChanged: _actions.setVideoInputDevice,
            handleAudioInputChanged: _setGenericAudioInputDevice["default"],
            showNotification: _actions.showNotification
          };
          sliPayload = {
            cameraState: isCameraOn ? 'ON' : 'OFF',
            isRemoteToggle: isRemoteToggle
          };
          _context8.prev = 3;
          _metrics.commonWebAnalytics.startStudioCameraToggled(sliPayload);
          _context8.next = 7;
          return (0, _videoHelpers.toggleAgoraVideo)(currentVideoTrack, isCameraOn, client, dispatch, deviceActions, attendeeId);
        case 7:
          newTrack = _context8.sent;
          if (!currentVideoTrack && newTrack) {
            dispatch((0, _actions.addToAttendeeTiles)(attendeeId, newTrack));
          }
          _metrics.commonWebAnalytics.endStudioCameraToggled(sliPayload);
          return _context8.abrupt("return", newTrack);
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](3);
          _metrics.commonWebAnalytics.endStudioCameraToggled(_objectSpread(_objectSpread({}, sliPayload), {}, {
            error: _context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message
          }));
          throw _context8.t0;
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[3, 13]]);
  }));
  return _toggleLocalUserVideoTrack.apply(this, arguments);
}
function toggleLocalUserAudioTrack(_x18) {
  return _toggleLocalUserAudioTrack.apply(this, arguments);
}
function _toggleLocalUserAudioTrack() {
  _toggleLocalUserAudioTrack = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(_ref2) {
    var currentAudioTrack, isMuted, client, dispatch, _ref2$isRemoteToggle, isRemoteToggle, deviceActions, sliPayload;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          currentAudioTrack = _ref2.currentAudioTrack, isMuted = _ref2.isMuted, client = _ref2.client, dispatch = _ref2.dispatch, _ref2$isRemoteToggle = _ref2.isRemoteToggle, isRemoteToggle = _ref2$isRemoteToggle === void 0 ? false : _ref2$isRemoteToggle;
          deviceActions = {
            handleAudioInputChanged: _setGenericAudioInputDevice["default"],
            showNotification: _actions.showNotification
          };
          sliPayload = {
            microphoneState: isMuted ? 'OFF' : 'ON',
            isRemoteToggle: isRemoteToggle
          };
          _context9.prev = 3;
          _metrics.commonWebAnalytics.startStudioMicrophoneToggled(sliPayload);
          _context9.next = 7;
          return (0, _audioHelper.muteLocalAudioStream)(currentAudioTrack, isMuted, client, dispatch, deviceActions);
        case 7:
          _metrics.commonWebAnalytics.endStudioMicrophoneToggled(sliPayload);
          _context9.next = 14;
          break;
        case 10:
          _context9.prev = 10;
          _context9.t0 = _context9["catch"](3);
          _metrics.commonWebAnalytics.endStudioMicrophoneToggled(_objectSpread(_objectSpread({}, sliPayload), {}, {
            error: _context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message
          }));
          throw _context9.t0;
        case 14:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[3, 10]]);
  }));
  return _toggleLocalUserAudioTrack.apply(this, arguments);
}